import React from 'react';
import { SecureRoute, LoginCallback } from '@okta/okta-react';
import { Switch, Route } from "react-router-dom";
import "@deere/ux.uxframe-core/dist/css/uxframe.min.css";
import { ThemeProvider, Box } from '@deere/fuel-react';
import RequestView from "../components/RequestView/RequestView";
import { NoAccessUser } from "./NoAccessUser";
import routes from "../shared/routes";
import { useUserInfo } from "./UserInfo";
import {Login} from "./Login";

export const Main = () => {
    const info = useUserInfo();
    const roles = info && info.roles;
    return (
        <div id="content">
            <ThemeProvider baseline={false}>
                <Route path="/implicit/callback" exact component={LoginCallback}/>
                <Route  path="/login" exact component={Login}/>
                <SecureRoute path="/" exact component={RequestView} />
                <Switch>
                    {routes.map(({ path, name, Component, role }, key) => (
                        <SecureRoute
                            exact
                            path={path}
                            key={key}
                            render={props => {
                                const crumbs = routes
                                    .filter(({ path }) => props.match.path.includes(path))
                                    .map(({ path, ...otherProps }) => ({
                                        path: Object.keys(props.match.params).length
                                            ? Object.keys(props.match.params).reduce(
                                                (path, param) =>
                                                    path.replace(`:${param}`, props.match.params[param]),
                                                path
                                            )
                                            : path,
                                        ...otherProps
                                    }));
                                return (
                                    <Box p={5}>
                                        <>
                                            {role !== "" && roles && !role.includes(roles) && (
                                                <NoAccessUser />
                                            )}
                                            {role !== "" && roles && role.includes(roles) && (
                                                <>
                                                    <Component {...props} name={name} />
                                                </>
                                            )}
                                            {role === "" && (
                                                <>
                                                    <Component {...props} name={name} />
                                                </>
                                            )}
                                        </>
                                    </Box>
                                );
                            }}
                        />
                    ))}
                </Switch>
            </ThemeProvider>
        </div>
    );
}